document.addEventListener("DOMContentLoaded", () => {
    const button = document.querySelector(
        ".sw-scroll-to.scroll-to-contact.sw-scroll-to-visible"
    );
    const container = document.querySelector("#tz-contact-article");
    const container2 = document.querySelector('label[for="sw-aside-left"]');

    if (!button) return;
    button.style.transition = "opacity 0.3s ease";

    const checkOverlap = () => {
        const rect = button.getBoundingClientRect();
        const hide = [container, container2].some((c) => {
            if (!c) return false;
            const r = c.getBoundingClientRect();
            return rect.bottom > r.top && rect.top < r.bottom;
        });

        button.style.opacity = hide ? "0" : "1";
        button.style.pointerEvents = hide ? "none" : "auto";
    };

    let ticking = false;
    const onScrollOrResize = () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                checkOverlap();
                ticking = false;
            });
            ticking = true;
        }
    };

    window.addEventListener("scroll", onScrollOrResize);
    window.addEventListener("resize", onScrollOrResize);
    checkOverlap();
});
